import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { transparentize } from "polished";

const RefPreviewLink = styled.span`
  display: inline-block !important;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  border-bottom: 3px solid
    ${({ theme }) =>
      transparentize(
        0.7,
        theme.darkMode ? theme.primaryText : theme.primary
      )} !important;
`;

const ScriptureRef = ({ refId, showRefPreview, children }) => (
  <RefPreviewLink onClick={() => showRefPreview(refId)}>
    {children}
  </RefPreviewLink>
);

ScriptureRef.propTypes = {
  refId: PropTypes.string.isRequired,
  showRefPreview: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    .isRequired,
  children: PropTypes.node.isRequired
};

export default ScriptureRef;
